import { tns } from "tiny-slider";

window.tns = tns;

window.Megasystemas = window.Megasystemas || {};
window.Megasystemas.tns = tns;
